'use client'
import { ErrorPdp } from '@/components/ErrorPdp'
import { Metadata } from 'next'

export const metadata: Metadata = {
  title: '404 - Page Not Found',
  description: 'The product you are looking for does not exist.',
}
const NotFound = () => {
  return <ErrorPdp />
}

export default NotFound
